module.exports = __webpack_public_path__ + "img/fist-hand.99af84fc.png";